import { render, staticRenderFns } from "./TransferLoan.vue?vue&type=template&id=63b35478&"
import script from "./TransferLoan.vue?vue&type=script&lang=js&"
export * from "./TransferLoan.vue?vue&type=script&lang=js&"
import style0 from "./TransferLoan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports